<div style="padding:10px;">
  <div class="col-md-8 clear-padding">
    <mat-form-field appearance="fill" floatLabel="always" style="width:100%;">
      <mat-label>Category Name</mat-label>
      <input matInput class="mat-focused" [(ngModel)]="CurrentCategory.Name"  id="txtCatName" />
    </mat-form-field>
    
      <app-category-select IsRoot="true" [(SelectedCategory)]="CurrentCategory.ParentID" [cats]="Categories">

      </app-category-select>
    

  </div>
</div>
